angular.module('impactx.basket').controller('SendBackBasketListCtrl', [
    '$scope',
    'selectedListItems',
    'dataGen',
    '$context',
    '$redirect',
    SendBackBasketListCtrl]);

function SendBackBasketListCtrl($scope, selectedListItems, dataGen, $context, $redirect)
{
    var self = this;

    self.canAddToBasket = function() {
        return selectedListItems.isSingleSelection() && impactX.isDefined($scope, '$$childHead.data.actions.canAddToBasket.allowed');
    };

    self.addToBasket = function() {
        dataGen.post($scope, {selected: selectedListItems.getSelectedIdsWithTypes()}, "/basket/activate", function () {
            $context.refreshBasket({}, dataGen, $context);
            $redirect.redirectTo(null, "/basket");
        });
    };

    var buttonDefinition = [
        {label: "addToBasket", action: self.addToBasket, condition:  self.canAddToBasket, process: 'ViewBasket'},
    ];

    this.meta = {
        rowTemplate: 'modules/basket/templates/sendbackbasketlist.row.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/basket/sendback/list',
        id: 'sendbackbasketlist',
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}